'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsBus = function MdDirectionsBus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 18.4v-8.4h-20v8.4h20z m-2.5 10c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-15 0c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-5.9-1.8v-16.6c0-5.9 6.1-6.6 13.4-6.6s13.4 0.7 13.4 6.6v16.6c0 1.5-0.7 2.9-1.8 3.8v3c0 0.9-0.7 1.6-1.6 1.6h-1.6c-1 0-1.8-0.7-1.8-1.6v-1.8h-13.2v1.8c0 0.9-0.8 1.6-1.8 1.6h-1.6c-0.9 0-1.6-0.7-1.6-1.6v-3c-1.1-1-1.8-2.3-1.8-3.8z' })
        )
    );
};

exports.default = MdDirectionsBus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-bus.js
// module id = 3245
// module chunks = 168707334958949